import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  employerApplicationsKey,
  createApplicationManuallyRoute,
  errorMessage,
  applicationsCountsKey,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type UseCreateApplicationProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
  isJson?: boolean
};

export const useCreateApplication = ({
  setErrorText = () => { },
  isJson
}: UseCreateApplicationProps) => {
  const client = useQueryClient();

  const { mutate: createApplication, isLoading: isCreateApplicationLoading } =
    useMutation({
      mutationFn: (variables: {
        job_listing_ids?: string;
        phone_number?: string;
        is_multiple?: boolean;
        s_name?: string;
        first_name?: string;
        last_name?: string;
        email?: string;
        hired?: boolean;
        resume_doc?: any;
        team_members?: {
          job_listing_ids: string | number;
          first_name: string;
          last_name: string;
          email: string;
          phone: string;
          hired?: boolean;
          position: string;
          matchedPositionId?: number | string;
      }[]
      }) =>
        axiosInstance
          .post(createApplicationManuallyRoute, variables, {
            headers: {
              'Content-Type': isJson ? 'application/json' : 'multipart/form-data',
            },
          })
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          client.invalidateQueries(employerApplicationsKey);
          client.invalidateQueries(applicationsCountsKey);
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    });

  return {
    createApplication,
    isCreateApplicationLoading,
  };
};
